import { render, staticRenderFns } from "./AsignacionEsquemas.vue?vue&type=template&id=6d6c1047&scoped=true&"
import script from "./AsignacionEsquemas.vue?vue&type=script&lang=ts&"
export * from "./AsignacionEsquemas.vue?vue&type=script&lang=ts&"
import style0 from "./AsignacionEsquemas.vue?vue&type=style&index=0&id=6d6c1047&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6d6c1047",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/portal-track3/portal-track3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!module.hot.data) {
      api.createRecord('6d6c1047', component.options)
    } else {
      api.reload('6d6c1047', component.options)
    }
    module.hot.accept("./AsignacionEsquemas.vue?vue&type=template&id=6d6c1047&scoped=true&", function () {
      api.rerender('6d6c1047', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pantallas/MID/AsignacionEsquemas.vue"
export default component.exports